import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckmarkIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <path
                id="Vector"
                d="M16.6666 5L7.49992 14.1667L3.33325 10"
                stroke="currentColor"
                fill="none"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
